import { useContext, useState } from 'react'
import { useForm } from 'react-hook-form'
import * as yup from "yup"
import { yupResolver } from "@hookform/resolvers/yup";
import { useFirebase } from 'react-redux-firebase'
import { getFunctions, httpsCallable } from "firebase/functions";

import Button from '@/components/Button'
import SocialRegister from '@/components/SocialRegister'
import { AuthContext } from '@/contexts/AuthContext'
import { ModalContext } from '@/contexts/ModalContext'
import resolveErrors from '../../utils/resolveErrors';

export default function RegisterPanel() {
  const { closeModal } = useContext(ModalContext)
  const [serverErrors, setServerErrors] = useState(null)
  const firebase = useFirebase()
  const functions = getFunctions()
  const functionRegister = httpsCallable(functions, 'register');
  const generateEmailVerificationLink = httpsCallable(functions, 'generateEmailVerificationLink');

  const schema = yup.object().shape({
    email: yup.string().email().required(),
    username: yup.string().min(3).max(16).required(),
    password: yup.string().min(8).max(32).required(),
  });

  const { register, handleSubmit, formState: { errors, isSubmitting } } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmitHandler = async ({ username, email, password }) => {
    try {
      await functionRegister({ email, password, username }).then(() => {
        firebase.auth().signInWithEmailAndPassword(email, password).then(() => {
          generateEmailVerificationLink({ email })
          closeModal()
        })
      })
    } catch (err) {
      setServerErrors(err.message)
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmitHandler)} className="mt-6 grid gap-4 text-sm">
        <div>
          <label className="block mb-1 font-medium">Username</label>
          <input {...register('username')} type="text" placeholder="Zezima" required className={errors?.username ? '!border-red-500' : ''} />
        </div>
        <div>
          <label className="block mb-1 font-medium">Email</label>
          <input {...register('email')} type="email" placeholder="john@example.com" required className={errors?.email ? '!border-red-500' : ''} />
        </div>
        <div>
          <label className="block mb-1 font-medium">Password</label>
          <input {...register('password')} type="password" placeholder="*****" required className={errors?.password ? '!border-red-500' : ''} />
        </div>
        <p className="text-xs text-center">By clicking Play Now, you are indicating that you have read and acknowledge the Terms & Conditions</p>
        {serverErrors && <p className="text-xs text-red-500 font-medium">{serverErrors}</p>}
        <Button modifier="primary" type="submit" className="py-3">
          {isSubmitting ? (
            <span className="flex items-center justify-center">
              Submitting
              <svg className="animate-spin ml-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
            </span>
          ) : (
            <span>Play Now</span>
          )}
        </Button>
      </form>
      <div className="mt-4 grid gap-5">
        {/* <p className="text-sm text-center">Or continue with</p> */}
        {/* <SocialRegister dark google /> */}
        <p className="text-xs text-center">This site is protected by hCaptcha and the hCaptcha Privacy Policy and Terms of Service apply.</p>
      </div>
    </>
  )
}